import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../../../Dashboards/Dashboard';
const TerminalRoot = () => (React.createElement(Switch, null,
    React.createElement(Route, { exact: true, path: '/dma', component: Dashboard }),
    React.createElement(Route, { exact: true, path: '/rfq', component: Dashboard })));
export default TerminalRoot;
